import React from "react";
import CText from "../Components/CText";

function AboutMe() {
  return (
    <div className="aboutMeContainer">
      <CText
        className="cw fw-bold"
        fontSize="2.5rem"
        text="Hi! I’m Abdullah Ibrahim. Nice to meet you."
      />
      <CText
        // style={{ padding: "30px 10%" }}
        className="cw subText"
        fontSize="1.3rem"
        text={
          <p> 
            Since the beginning of my career, I've been actively involved in
            developing modern web applications using web3 technologies, React,
            SCSS/CSS, and other related frontend technologies. I've successfully
            completed several projects that demonstrate my ability to create
            intuitive and engaging user experiences.
            <span>
              <br />
            </span>{" "}
            While I may not consider myself an expert or possess exceptional
            development skills, I have a strong drive to constantly improve
            myself both technically and personally. I embrace every opportunity
            to learn new concepts, explore emerging technologies, and refine my
            craft as a frontend developer. I love what I do.
          </p>
        }
      />
    </div>
  );
}

export default AboutMe;
